<section class="fdk-state-view">
  <fdk-illustration [name]="illustration" />

  <div class="fdk-state-view__content">
    <h2 class="fdk-state-view__title">{{ title }}</h2>
    <p class="fdk-state-view__subtitle">{{ subtitle }}</p>
  </div>
</section>
